import { useGet330DetailQuery } from '@/api/user/userApiSlice';
import AppFieldView from '@/common/components/form-view/AppFieldView';
import { Box, CardContent, Grid, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import Divider from '@mui/material/Divider';

interface Props {}
export default function User330Detail(props: Props) {
	const { t } = useTranslation();
	const { id } = useParams();

	const { data: user330Detail } = useGet330DetailQuery(id || '', {
		refetchOnMountOrArgChange: true,
	});
	console.log(user330Detail);

	return (
		<>
			<CardContent sx={{ padding: '24px' }}>
				<Box display='flex' justifyContent='space-between'>
					<Typography variant='h6'>{t('user.record330')}</Typography>
				</Box>
				<Grid container spacing={3} marginTop={0} marginBottom={3}>
					<Grid item xs={6}>
						<AppFieldView
							label={t('user.totalMindfulnessTime')}
							value={
								user330Detail?.data?.record330?.totalMindfulnessTime || '0'
							}
						/>
					</Grid>
					<Grid item xs={6}>
						<AppFieldView
							label={t('user.dayLongestTime')}
							value={user330Detail?.data?.record330?.dayLongestTime || '0'}
						/>
					</Grid>
					<Grid item xs={6}>
						<AppFieldView
							label={t('user.dayAverageTime')}
							value={user330Detail?.data?.record330?.dayAverageTime || '0'}
						/>
					</Grid>
					<Grid item xs={6}>
						<AppFieldView
							label={t('user.totalRecordDays')}
							value={user330Detail?.data?.record330?.totalRecordDays || '0'}
						/>
					</Grid>
				</Grid>
				<Divider />

				<Box
					display='flex'
					justifyContent='space-between'
					sx={{ paddingTop: '24px' }}
				>
					<Typography variant='h6'>{t('user.recordHealth')}</Typography>
				</Box>
				<Grid container spacing={3} marginTop={0} marginBottom={3}>
					<Grid item xs={6}>
						<AppFieldView
							label={t('user.totalCount')}
							value={user330Detail?.data?.recordHealth?.totalCount || '0'}
						/>
					</Grid>
					<Grid item xs={6}>
						<AppFieldView
							label={t('user.belowAverageCount')}
							value={
								user330Detail?.data?.recordHealth?.belowAverageCount || '0'
							}
						/>
					</Grid>
					<Grid item xs={6}>
						<AppFieldView
							label={t('user.withinAverageCount')}
							value={
								user330Detail?.data?.recordHealth?.withinAverageCount || '0'
							}
						/>
					</Grid>
					<Grid item xs={6}>
						<AppFieldView
							label={t('user.aboveAverageCount')}
							value={
								user330Detail?.data?.recordHealth?.aboveAverageCount || '0'
							}
						/>
					</Grid>
				</Grid>
				<Divider />

				<Box
					display='flex'
					justifyContent='space-between'
					sx={{ paddingTop: '24px' }}
				>
					<Typography variant='h6'>{t('user.recordGame')}</Typography>
				</Box>
				<Grid container spacing={3} marginTop={0} marginBottom={3}>
					<Grid item xs={6}>
						<AppFieldView
							label={t('user.totalPoints')}
							value={user330Detail?.data?.recordGame?.totalPoints || '0'}
						/>
					</Grid>
					<Grid item xs={6}>
						<AppFieldView
							label={t('user.usedPoints')}
							value={user330Detail?.data?.recordGame?.usedPoints || '0'}
						/>
					</Grid>
					<Grid item xs={6}>
						<AppFieldView
							label={t('user.remainingPoints')}
							value={user330Detail?.data?.recordGame?.remainingPoints || '0'}
						/>
					</Grid>
					<Grid item xs={6}>
						<AppFieldView
							label={t('user.treasureCount')}
							value={user330Detail?.data?.recordGame?.treasureCount || '0'}
						/>
					</Grid>
				</Grid>
				<Divider />

				<Box
					display='flex'
					justifyContent='space-between'
					sx={{ paddingTop: '24px' }}
				>
					<Typography variant='h6'>{t('user.record21List')}</Typography>
				</Box>
				<Grid container spacing={3} marginTop={0} marginBottom={3}>
					{(user330Detail?.data?.record21List || []).map((item, index) => (
						<Grid item xs={6} key={index}>
							<AppFieldView label={item.title} value={`${item.progress}/21`} />
						</Grid>
					))}
				</Grid>
				<Divider />

				<Box
					display='flex'
					justifyContent='space-between'
					sx={{ paddingTop: '24px' }}
				>
					<Typography variant='h6'>{t('user.recordOtherExercise')}</Typography>
				</Box>
				<Grid container spacing={3} marginTop={0} marginBottom={3}>
					<Grid item xs={6}>
						<AppFieldView
							label={t('user.mostExercise')}
							value={user330Detail?.data?.recordOtherExercise?.mostExercise}
						/>
					</Grid>
					<Grid item xs={6}>
						<AppFieldView
							label={t('user.finishExercise21')}
							value={
								user330Detail?.data?.recordOtherExercise?.finishExercise21 ||
								'0'
							}
						/>
					</Grid>
					<Grid item xs={6}>
						<AppFieldView
							label={t('user.finishExerciseCrossover')}
							value={
								user330Detail?.data?.recordOtherExercise
									?.finishExerciseCrossover || '0'
							}
						/>
					</Grid>
					<Grid item xs={6}>
						<AppFieldView
							label={t('user.finishExerciseMindfulJar')}
							value={
								user330Detail?.data?.recordOtherExercise
									?.finishExerciseMindfulJar || '0'
							}
						/>
					</Grid>
					<Grid item xs={6}>
						<AppFieldView
							label={t('user.finishExerciseInPerson')}
							value={
								user330Detail?.data?.recordOtherExercise
									?.finishExerciseInPerson || '0'
							}
						/>
					</Grid>
					<Grid item xs={6}>
						<AppFieldView
							label={t('user.finishExerciseUnitMeditation')}
							value={
								user330Detail?.data?.recordOtherExercise
									?.finishExerciseUnitMeditation || '0'
							}
						/>
					</Grid>
					<Grid item xs={6}>
						<AppFieldView
							label={t('user.finishExerciseUnitBodyMind')}
							value={
								user330Detail?.data?.recordOtherExercise
									?.finishExerciseUnitBodyMind || '0'
							}
						/>
					</Grid>
				</Grid>
			</CardContent>
		</>
	);
}
